module.exports = __webpack_public_path__ + "img/grp1.547022c5.jpg";